import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Link, NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StockNavbar from "./StockNavbar";
import Pagination from "../General/Pagination";

const ManageStockRegisterTypes = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [listOfRecords, setListOfRecords] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    document.title = "Manage Stock Register Types";
    setLoading(true);

    axios({
      method: "post",
      url: config.base_url + "Stock/GetStockRegisterTypes",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo,
        pageSize,
        RegisterName: searchName,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setListOfRecords(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setListOfRecords([]);
          setTotalRecords(0);
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  }, [pageNo, pageSize, isUpdated, searchName, AccessKey, UserID, MemberType]);

  const deleteRecord = (id) => {
    if (!window.confirm("Delete this register type?")) {
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "Stock/DeleteStockRegisterType",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, ID: id },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsUpdated((v) => !v);
        } else {
          toast.error(response.data.status_message || "Delete failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function () {
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const renderRows = () => {
    if (listOfRecords.length > 0) {
      return listOfRecords.map((item, index) => (
        <tr key={index}>
          <td>{item.ID}</td>
          <td>{item.RegisterName}</td>
          <td>{item.Is_Active ? "Yes" : "No"}</td>
          <td className="text-center">
            <ul className="inline-action">
              <li>
                <NavLink
                  to={`/StockManagement/EditStockRegisterType/${item.ID}`}
                  className="green"
                >
                  <i className="ri-edit-line"></i>
                </NavLink>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => deleteRecord(item.ID)}
                  className="red"
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              </li>
            </ul>
          </td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan="4">
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No register types found.
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <StockNavbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/StockManagement/StocksDashboard">Stocks</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Register Types
                  </li>
                </ol>
              </nav>
              <div className="page-title">Manage Stock Register Types</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/StockManagement/AddStockRegisterType"
                  className="button button-white button-icon"
                >
                  Add Register Type
                  <i className="ri-add-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card mb-2">
            <div className="card-body p-md-4">
              <div className="row align-items-end gy-2">
                <div className="col-md-4">
                  <label>Search register name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={searchName}
                    onChange={(e) => {
                      setPageNo(1);
                      setSearchName(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body table_card">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Register Name</th>
                    <th>Active</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : (
                    renderRows()
                  )}
                </tbody>
              </table>
              {totalRecords > pageSize && (
                <div className="pagination-wrap">
                  <Pagination
                    pageNo={pageNo}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    onPageChange={setPageNo}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageStockRegisterTypes;
